module.exports = __webpack_public_path__ + "resources/img/main03_gov.89aedc01396b84cebf3069539f057613.png";